import { HttpStatusCode } from 'axios';
import { ApiRequest } from '../../Handlers/ApiReqest';
import { Shipment } from '../../Models/Shipment';
import { InterActive } from '../../utilities/ViewModelStructure'
import { Notify } from '../../Handlers/Notifications';
export class ShippmentsReportVM extends InterActive{
    private data:Shipment[] =[] ;
    public get Data():Shipment[]{ return this.data  }
    public set Data(value:Shipment[]){ this.data = value ; this.update()  }

    private finished:boolean = false;
    public get Finished():boolean{ return this.finished  }
    public set Finished(value:boolean){ this.finished = value ; this.update()  }

    private search:string = '';
    public get Search():string{ return this.search  }
    public set Search(value:string){ this.search = value ; this.update()  }

    private isDone:''|'done'|'waiting' = '';
    public get IsDone():''|'done'|'waiting'{ return this.isDone  }
    public set IsDone(value:''|'done'|'waiting'){ this.isDone = value ; this.update()  }


    public async saveNotes(id:string, value:string,onfail:()=>void){
        try{
            const response = await ApiRequest.editeShippingNumberNotes(id , value)
            if(response){
                if(response.status==HttpStatusCode.Ok){
                    if(response.data.status){

                    }else{
                        onfail()
                        Notify({type:'danger' , title:'فشل عملية الازالة', body:response.data.messege})
                    }
                }else Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
            }
        }catch{
            Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
        }
        
    }

    public getData(){
        this.loading(
            async()=>{
                try{
                    const response = await ApiRequest.getShipments('0' , this.search , this.isDone)
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                this.data = [...response.data.data]
                                this.finished = false
                                this.update()
                            }else Notify({type:'danger' , title:'فشل عملية الازالة', body:response.data.messege})
                        }else Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{
                    Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }
            }
        )
    }

    
    public async getMore(){
        if(!this.finished){
            if(this.data.length>0){
                try{
                    const response = await ApiRequest.getShipments(this.data[this.data.length-1].id, this.search, this.isDone)
                    if(response){
                        if(response.status === HttpStatusCode.Ok){
                            if(response.data.status){
                                if(response.data.data.length>0){
                                    this.data = [...this.data,...response.data.data]
                                    this.finished=false
                                    this.update()
                                }
                                else {
                                    this.finished = true
                                    this.update()
                                }
                            }else Notify({type:'danger' , title:'فشل عملية الازالة', body:response.data.messege})
                        }else Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                    }
                }catch{
                    Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
                }
            }
        }
        
    }

    public async editStatus(id:string , value:'done'|'waiting'){
        this.data.map(item=>item.status=item.id==id?value:item.status)
        this.update()
    }

    public async recieved(id:string){
        try{
            this.editStatus(id , 'done')
            const response = await ApiRequest.activateShippingNumber(id)
            if(response){
                if(response.status === HttpStatusCode.Ok){
                    if(!response.data.status){
                        this.editStatus(id, 'waiting')
                        Notify({type:'danger' , title:'فشل عملية الازالة', body:response.data.messege})
                        this.update()
                    }
                }else Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
            }
        }catch{
            Notify({type:'danger' , title:'فشل عملية الازالة', body:'فشل عملية الازالة .. برجاء مراجعة الاتصال بالانترنت و المحاولة مرة اخرى'})
        }
    }
}